<template>
<v-main class="pa-5 pb-4">

  <v-flex v-show="!clicouEditar">

    <v-card>
      <v-card-title>
        <v-toolbar-title>Títulos cadastrados
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" no-data-text="Nenhum item disponível" :items="listaTitulos" :search="search">
        <template v-slot:items="props">
          <td class="title">{{ props.item.titulo }}</td>
          <!-- <td class="text-xs-right">{{ props.item.idUnidade }}</td> -->

          <!-- <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab small v-on="on">
                  <v-icon color="success" small @click="editarDadosHelp(props.item)">
                    edit
                  </v-icon>
                </v-btn>
              </template>
              <span>Alterar Descrição </span>
            </v-tooltip>

          </td> -->
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editarDadosHelp(item)">
            mdi-pencil
          </v-icon>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <v-flex v-show="clicouEditar">
    <v-layout justify-center class="mt-2">
      <v-card width="1200" class="rounded-xl">
        <v-form v-model="valid" ref="form" class="mx-4">
          <v-text-field label="Descrição do Título" v-model="titulo" :rules="tituloRules" required></v-text-field>
          <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concordar para salvar']" required></v-checkbox>
          <v-alert :value="erroSalvar" color="error" icon="warning" outlined>
            Erro ao cadastrar título !!
          </v-alert>

        </v-form>
        <v-card-actions>
          <v-spacer />
            <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
            <v-btn text @click="" @click="voltar()">
              <v-icon left>keyboard_backspace</v-icon>
              voltar
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-flex>

  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="" :to="{path:'/cadastrarTituloHelp'}">
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

export default {
  name: 'listaAdministrador',
  data () {
    return {
      page: 1,
      checkbox: false,
      erroSalvar: false,
      blockMethod: false,
      valid: false,
      listaTitulos: [],
      clicouEditar: false,
      titulo: '',
      idTituloHelp: '',
      search: '',
      isEditing: true,
      tituloRules: [
        (v) => !!v || 'Título obrigatório'
      ],
      headers: [{
        text: 'Descrição do título',
        align: 'center',
        sortable: true,
        value: 'titulo'
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false
      }

      ],
      listaLocais: [],
      user: null,
      items: [{
        nomeLocal: 'aaa!',
        idLocal: '1'
      },
      {
        nomeLocal: 'bbb',
        idLocal: '3'
      },
      {
        nomeLocal: 'ccc',
        idLocal: '2'
      },
      {
        nomeLocal: 'ddd',
        idLocal: '15'
      },
      {
        nomeLocal: 'eee',
        idLocal: '31'
      },
      {
        nomeLocal: 'fff',
        idLocal: '22'
      }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario

    if (this.user.tipo != 10) {
      this.$router.push('/login')
      return
    }
    // console.log(this.user);
    this.retornarTituloHelp()
  },
  methods: {

    voltar () {
      this.clicouEditar = false
    },

    editarDadosHelp (item) {
      console.log(item)
      this.clicouEditar = true
      this.titulo = item.titulo
      this.idTituloHelp = item.idTituloHelp
    },

    retornarTituloHelp () {
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .retornarTituloHelp()
        .then(rsp => {
          console.log('rsp retornarTituloHelp:', rsp.data)
          this.listaTitulos = rsp.data
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.erroSalvar = false,
        administradorDesenvolvimentoService.administradorDesenvolvimento
          .alterarTituloHelp(this.titulo, this.idTituloHelp)
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            if (rsp.data == false) {
              this.erroSalvar = true
            }
            if (rsp.data == true) {
              this.listaTitulos = []
              this.clicouEditar = false
              this.retornarTituloHelp()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    }

  },
  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
